import React from 'react';
import icon1 from './images/icon1.png';
import icon2 from './images/icon2.png';
import icon3 from './images/icon3.png';
import icon4 from './images/icon4.png';
import icon5 from './images/icon5.png';
import icon6 from './images/icon6.png';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
const responsive = {
  superLargeDesktop: {
   
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};


const Services = () => {
  

  return (
   
    <div classNameName="container my-5">
    <div classNameName="row"><h2 classNameName='text-center'>Choose Us for the Best Quality Service</h2></div>

    <div classNameName="row pt-3 pb-5">

    <Carousel responsive={responsive}>
   
   <div className="card service-card d-flex justify-content-center align-items-center" >
    <img className="card-img-top service-icon" src={icon1} alt="error"/>
    <div className="card-body">
      <h6 className="card-title">10 Years Warranty</h6>
    </div>
  </div>

  <div className="card service-card d-flex justify-content-center align-items-center" >
    <img className="card-img-top service-icon" src={icon2} alt="error"/>
    <div className="card-body">
      <h6 className="card-title">Quality Check</h6>
    </div>
  </div>


  <div className="card service-card d-flex justify-content-center align-items-center" >
  <img className="card-img-top service-icon" src={icon3} alt="error"/>
  <div className="card-body">
    <h6 className="card-title">Happy Clients</h6>
  </div>
</div>


<div className="card service-card d-flex justify-content-center align-items-center" >
  <img className="card-img-top service-icon" src={icon4} alt="error"/>
  <div className="card-body">
    <h6 className="card-title">300+ Designers</h6>
  </div>
</div>


<div className="card service-card d-flex justify-content-center align-items-center" >
  <img className="card-img-top service-icon" src={icon5} alt="error"/>
  <div className="card-body">
    <h6 className="card-title">catalogue products</h6>
  </div>
</div>

<div className="card service-card d-flex justify-content-center align-items-center" >
  <img className="card-img-top service-icon" src={icon6} alt="error"/>
  <div className="card-body">
    <h6 className="card-title">catalogue products</h6>
  </div>
</div>
   
    
 
</Carousel>
</div>

</div>
  );
}

export default Services;
